module.exports = __webpack_public_path__ + "static/media/ie.b0281918.jpg";